import { formatApiErrorDetail } from "@/lib/api";

// Maps known backend (German) error details to i18n keys so error toasts translate
// automatically — WITHOUT changing the backend API contract. Unmapped messages fall
// back to the raw backend detail (still informative), then to a generic message.
const RULES = [
  [/FUNDIO CLAIM QA|QA[^.]*schreibbar/i, "errors.qaOnlyWrite"],
  [/Unbekannte Pipeline-Stufe/i, "errors.unknownStage"],
  [/Claim nicht gefunden/i, "errors.claimNotFound"],
  [/Organisation nicht gefunden/i, "errors.orgNotFound"],
  [/(gültige|ungültige)\s*E-?Mail/i, "errors.invalidEmail"],
  [/Ungültige Sprache/i, "errors.invalidLanguage"],
];

export function translateApiError(t, detail) {
  const raw = formatApiErrorDetail(detail);
  for (const [re, key] of RULES) {
    if (re.test(raw)) return t(key);
  }
  return raw || t("errors.generic");
}
